import EntryContainer from "../../../containers/EntryContainer"

export const Entries = (): JSX.Element => {
  return <EntryContainer />
}
